var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCatDog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 581 255.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#d6edfc;}.cls-3{fill:#ffce49;}.cls-4{fill:#00b4cf;}.cls-5{fill:#123546;}.cls-6{fill:#fff;}.cls-7,.cls-8{fill:#33bacf;}.cls-7{opacity:0.3;isolation:isolate;}.cls-9{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.03,
    cy: 176.98,
    r: 7.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FONDOS_LOGO",
    "data-name": "FONDOS LOGO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1122",
    "data-name": "Grupo 1122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1117",
    "data-name": "Grupo 1117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078",
    "data-name": "Grupo 1078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_699",
    "data-name": "Trazado 699",
    className: "cls-2",
    d: "M199.82,59.24,526.54,40.7a12.82,12.82,0,0,1,12.85,16.92l-27.14,79.85c-1.13,3.32-4.27,5.54-7.77,2.48l-284.83-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_700",
    "data-name": "Trazado 700",
    className: "cls-3",
    d: "M270.18,136.92l294-16.68a16,16,0,0,1,16,21.07L561,197.82a23.4,23.4,0,0,1-22.45,15.87l-238.68-2.95a14.78,14.78,0,0,1-14.17-11.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1073",
    "data-name": "Grupo 1073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_701",
    "data-name": "Trazado 701",
    className: "cls-4",
    d: "M249.61,107.26a4.81,4.81,0,0,1-2.31-4.13,4.69,4.69,0,0,1,4.6-4.76h.17a4.64,4.64,0,0,1,2.38.63A22.38,22.38,0,0,0,266,102.82c3.5,0,5.09-1.27,5.09-3.18v-.16c0-2.62-4.13-3.49-8.82-4.92-6-1.75-12.7-4.52-12.7-12.78v-.16c0-8.65,7-13.5,15.56-13.5a29.92,29.92,0,0,1,13.18,3.26,4.92,4.92,0,0,1,2.86,4.52,4.76,4.76,0,0,1-4.73,4.77h-.12a4.33,4.33,0,0,1-2.22-.55,22.57,22.57,0,0,0-9.21-2.7c-2.94,0-4.45,1.27-4.45,2.94v.16c0,2.38,4.05,3.49,8.66,5.08,5.95,2,12.86,4.84,12.86,12.62v.16c0,9.44-7.07,13.74-16.28,13.74A29.55,29.55,0,0,1,249.61,107.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_702",
    "data-name": "Trazado 702",
    className: "cls-4",
    d: "M309.05,112.26c-12.78,0-22.22-9-22.22-22v-.16c0-12.15,8.65-22.15,21-22.15,14.22,0,20.49,11.67,20.49,20.48a5.5,5.5,0,0,1-5.21,5.79H298.81a9.87,9.87,0,0,0,10.4,8.34,14,14,0,0,0,8.58-2.86,4.43,4.43,0,0,1,2.93-1,4.61,4.61,0,0,1,4.69,4.54v.22a4.72,4.72,0,0,1-1.59,3.57A22,22,0,0,1,309.05,112.26Zm7.78-25.56c-.71-5.4-3.89-9-9-9s-8.26,3.57-9.21,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_703",
    "data-name": "Trazado 703",
    className: "cls-4",
    d: "M338.29,121.24a4.93,4.93,0,0,1,3.09-9.37l.4.15a27.39,27.39,0,0,0,11.75,2.55c8.26,0,12.15-4,12.15-11.6v-2.06a16.66,16.66,0,0,1-13.9,6.91c-9.92,0-18.9-7.23-18.9-19.85v-.16C332.88,75.1,342,68,351.78,68a17.21,17.21,0,0,1,13.74,6.35v-.08a6,6,0,0,1,12.07.08v27.38c0,7.63-1.83,13.18-5.4,16.76-4,4-10.08,5.72-18.34,5.72A40.81,40.81,0,0,1,338.29,121.24ZM365.68,88v-.16a10.37,10.37,0,0,0-20.72,0V88a9.72,9.72,0,0,0,9.57,9.86c.25,0,.5,0,.75,0a9.83,9.83,0,0,0,10.38-9.25c0-.2,0-.4,0-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_704",
    "data-name": "Trazado 704",
    className: "cls-4",
    d: "M424,105.75a6,6,0,1,1-12.07,0v-.47c-2.78,3.57-6.35,6.82-12.47,6.82-9.13,0-14.45-6-14.45-15.8v-22a6,6,0,1,1,12.07,0V92.49c0,5.72,2.7,8.65,7.31,8.65s7.54-2.93,7.54-8.65V74.31a6,6,0,1,1,12.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_705",
    "data-name": "Trazado 705",
    className: "cls-4",
    d: "M433.19,74.31a6,6,0,1,1,12.07,0v1.9c1.74-4.13,4.6-7.94,8.17-7.94a5.84,5.84,0,0,1,1.35,11.52c-6.11,1.43-9.53,6.11-9.53,14.69v11.27a6,6,0,1,1-12.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_706",
    "data-name": "Trazado 706",
    className: "cls-4",
    d: "M459.84,90.27v-.16c0-12.23,9.84-22.15,23.1-22.15s22.95,9.76,22.95,22v.16c0,12.23-9.85,22.15-23.11,22.15S459.84,102.5,459.84,90.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1072",
    "data-name": "Grupo 1072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1071",
    "data-name": "Grupo 1071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_707",
    "data-name": "Trazado 707",
    className: "cls-2",
    d: "M482.44,102.9c-1.29.3-2.57.63-3.87.89a10.64,10.64,0,0,1-2.69.37,4.47,4.47,0,0,1-4.11-4.8,4.63,4.63,0,0,1,.1-.65,8.33,8.33,0,0,1,2.47-4.34c1-1.07,2-2.24,2.94-3.39.7-.85,1.32-1.77,2.05-2.58a4.65,4.65,0,0,1,6.59-.06c.06,0,.1.1.15.15.67.79,1.2,1.69,1.85,2.5.93,1.17,1.85,2.36,2.88,3.43a7.3,7.3,0,0,1,2.53,5.6,4.46,4.46,0,0,1-4.73,4.17l-.28,0c-1.46-.22-2.89-.65-4.33-1-.5-.11-1-.13-1.51-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_708",
    "data-name": "Trazado 708",
    className: "cls-2",
    d: "M483.81,82.11a6.83,6.83,0,0,1,1.65-4.69,3.47,3.47,0,0,1,3.31-1.34,3.36,3.36,0,0,1,2.58,2.61,6.55,6.55,0,0,1-1.85,6.55,3.14,3.14,0,0,1-5.34-1.47A10.42,10.42,0,0,1,483.81,82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_709",
    "data-name": "Trazado 709",
    className: "cls-2",
    d: "M474,80.57a5.22,5.22,0,0,1,.78-3,2.94,2.94,0,0,1,4-1.13,2.8,2.8,0,0,1,.4.27,5.8,5.8,0,0,1,2.28,5.06,5,5,0,0,1-.91,2.92,2.9,2.9,0,0,1-4,.85l-.13-.09A5.76,5.76,0,0,1,474,80.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_710",
    "data-name": "Trazado 710",
    className: "cls-2",
    d: "M490.75,88.88a5.59,5.59,0,0,1,2.46-4.49,3.08,3.08,0,0,1,5,2.71A5.4,5.4,0,0,1,496,91.56a3.19,3.19,0,0,1-3.51.48A3.36,3.36,0,0,1,490.75,88.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_711",
    "data-name": "Trazado 711",
    className: "cls-2",
    d: "M474.66,88.93a5.56,5.56,0,0,1-.09.82,2.94,2.94,0,0,1-3.24,2.61,3,3,0,0,1-1.71-.79,5.23,5.23,0,0,1-2-5.48A2.89,2.89,0,0,1,471,83.71a2.94,2.94,0,0,1,1.2.49A5.56,5.56,0,0,1,474.66,88.93Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1077",
    "data-name": "Grupo 1077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1076",
    "data-name": "Grupo 1076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_712",
    "data-name": "Trazado 712",
    className: "cls-5",
    d: "M299.79,154.08a6,6,0,1,1,12.07,0v.55a15.64,15.64,0,0,1,13.26-6.9c9.93,0,19.38,7.78,19.38,22v.16c0,14.21-9.29,22-19.38,22a16.37,16.37,0,0,1-13.26-6.36v12.71a6,6,0,0,1-12.07,0Zm32.64,15.8v-.16c0-7.07-4.77-11.75-10.4-11.75s-10.33,4.68-10.33,11.75v.16c0,7.07,4.69,11.75,10.33,11.75s10.4-4.6,10.4-11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_713",
    "data-name": "Trazado 713",
    className: "cls-5",
    d: "M371.42,192c-12.78,0-22.22-9-22.22-22v-.16c0-12.15,8.65-22.15,21-22.15,14.22,0,20.49,11.67,20.49,20.49a5.52,5.52,0,0,1-5.21,5.79H361.18a9.87,9.87,0,0,0,10.4,8.34,13.91,13.91,0,0,0,8.58-2.86,4.48,4.48,0,0,1,2.93-1,4.61,4.61,0,0,1,4.69,4.54v.22a4.72,4.72,0,0,1-1.59,3.57A22,22,0,0,1,371.42,192Zm7.78-25.57c-.71-5.4-3.89-9.05-9-9.05S362,161,361,166.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_714",
    "data-name": "Trazado 714",
    className: "cls-5",
    d: "M396.89,138.68a6,6,0,0,1,12.07,0v46.87a6,6,0,1,1-12.07,0V138.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_715",
    "data-name": "Trazado 715",
    className: "cls-5",
    d: "M454.92,185.52a6,6,0,1,1-12.07,0V185c-2.78,3.57-6.35,6.83-12.47,6.83-9.13,0-14.45-6-14.45-15.8v-22a6,6,0,1,1,12.07,0v18.18c0,5.71,2.7,8.65,7.3,8.65s7.55-2.94,7.55-8.65V154.07a6,6,0,0,1,12.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_716",
    "data-name": "Trazado 716",
    className: "cls-5",
    d: "M505.89,185.52a6,6,0,1,1-12.07,0V185a15.64,15.64,0,0,1-13.26,6.91c-9.93,0-19.38-7.79-19.38-22v-.16c0-14.21,9.29-22,19.38-22a16.33,16.33,0,0,1,13.26,6.35v-15.4a6,6,0,1,1,12.07,0Zm-32.63-15.8v.16c0,7.07,4.77,11.75,10.41,11.75S494,177,494,169.88v-.16c0-7.06-4.69-11.75-10.32-11.75S473.26,162.59,473.26,169.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_717",
    "data-name": "Trazado 717",
    className: "cls-5",
    d: "M513.43,170v-.16c0-12.23,9.85-22.15,23.11-22.15s23,9.77,23,22v.16c0,12.23-9.85,22.16-23.11,22.16S513.43,182.27,513.43,170Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1075",
    "data-name": "Grupo 1075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1074",
    "data-name": "Grupo 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_718",
    "data-name": "Trazado 718",
    className: "cls-3",
    d: "M542.6,184.08c-1.21-.28-2.36-.46-3.47-.8a10,10,0,0,0-6,0,13.83,13.83,0,0,1-4.29.66,4.61,4.61,0,0,1-3.63-2.68,6.09,6.09,0,0,1-.28-.75,2.22,2.22,0,0,1,.94-2.8,12.11,12.11,0,0,0,4.53-5.09c.56-1.18.91-2.49,1.55-3.63a6,6,0,0,1,1.76-1.8,3.81,3.81,0,0,1,3-.61,5.73,5.73,0,0,1,2.5.88,1.31,1.31,0,0,1,.54,1,12.56,12.56,0,0,0,5.07,9.07,18.68,18.68,0,0,0,1.67,1c1.06.56,1.16.93.85,2.07a4.4,4.4,0,0,1-2.41,2.91A12.92,12.92,0,0,1,542.6,184.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_719",
    "data-name": "Trazado 719",
    className: "cls-3",
    d: "M529.91,153.18a5,5,0,0,1,.57,1.18c.09.48.39.55.75.74a6.84,6.84,0,0,1,1.92,1.36,6.45,6.45,0,0,1,1.67,5.74,3.75,3.75,0,0,1-3.46,3.28,3.66,3.66,0,0,1-3.46-2.09,6.69,6.69,0,0,1-.42-4.91,5.69,5.69,0,0,1,1.57-3c.14-.13.11-.46.11-.69A1.55,1.55,0,0,1,529.91,153.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_720",
    "data-name": "Trazado 720",
    className: "cls-3",
    d: "M542.46,153.65c.58.72.88,1.3.59,2.06a.6.6,0,0,0,.12.52,6.22,6.22,0,0,1,1.56,3.72,4.77,4.77,0,0,1-2,4.86,3.24,3.24,0,0,1-4.51-.81,2.72,2.72,0,0,1-.34-.63,6.59,6.59,0,0,1,2.43-7.4,1.41,1.41,0,0,1,.7-.32c.62,0,.76-.41.93-.87A9.89,9.89,0,0,1,542.46,153.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_721",
    "data-name": "Trazado 721",
    className: "cls-3",
    d: "M522.58,163.33a5.61,5.61,0,0,1,4.39,4,4.06,4.06,0,0,1-.29,3.59,3.11,3.11,0,0,1-5.33.23,4.66,4.66,0,0,1-1.05-2.62,6.57,6.57,0,0,1,.77-4.21c.11-.18,0-.47.06-.71a8.83,8.83,0,0,1,.25-1.54c.14-.42.46-.39.67,0S522.39,162.88,522.58,163.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_722",
    "data-name": "Trazado 722",
    className: "cls-3",
    d: "M544.52,169.45a5.4,5.4,0,0,1,3.67-4.69c.62-.08.34-.72.64-1,.12-.11.11-.35.21-.49a4.32,4.32,0,0,1,.45-.5c.16.2.43.39.45.61a11.87,11.87,0,0,1,0,1.58c0,.14-.07.31,0,.42a5.54,5.54,0,0,1,.63,3.88,4,4,0,0,1-1.8,2.76,2.52,2.52,0,0,1-2.84.12A2.84,2.84,0,0,1,544.52,169.45Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1115",
    "data-name": "Grupo 1115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1114",
    "data-name": "Grupo 1114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1113",
    "data-name": "Grupo 1113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_723",
    "data-name": "Trazado 723",
    className: "cls-6",
    d: "M43.62,112.49C69,89.41,131,41.18,209.48,36.46A19.35,19.35,0,0,1,230,54.54c0,.11,0,.22,0,.33,2.5,51.89-14.36,133.62-93.46,194.14a31.08,31.08,0,0,1-36,1.38c-41.48-27.51-73.11-58.5-71.8-105.89A45,45,0,0,1,43.62,112.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_724",
    "data-name": "Trazado 724",
    className: "cls-6",
    d: "M144.55,69.27s-8.49,14.55-24.29,17.06c-3.05,6.49-11.71,18.88,7,42.42,7.21-.7,28.47-1,28.47-1s-1.07-24.66-5.29-33.16c8,1.25,13.76,2.14,15.76,5.44s16,99.74,16,99.74L129.52,212l-4.34,32.12s-19.1-18.12-16.66-50.23c-3,.13-11.68-5.32-11.68-5.32S81,212.75,82.73,236.73c1,8-11.83-8.59-11.83-8.59l-2.34-16.9-3.31-31-25.74-3.13-4.13-20.75s18,13.13,29.61,13.5c-.13-7.62,3.56-60.08,3.56-60.08l1.68-49.47,8.42-7.64L117.45,38l17-3.88,10.11,12.46L148.32,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_725",
    "data-name": "Trazado 725",
    className: "cls-6",
    d: "M69.06,223.61s8.13,21.13,11.58,20.5A41.69,41.69,0,0,0,83.76,229Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1079",
    "data-name": "Grupo 1079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_726",
    "data-name": "Trazado 726",
    className: "cls-7",
    d: "M179.36,140.72l.42-1.68-7.59.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_727",
    "data-name": "Trazado 727",
    className: "cls-7",
    d: "M80.61,160.94s-6.11-16.66,7.08,2c7.87,11.14,18.09,12.89,24.87,15,4.8-8,18-25.51,41.3-26.52,1.18-5.06,1.48-14.2,1.85-16.62-9-2.6-28.46.89-35.2,1.59-.5.06-.73-.63-.4-1,1.33-1.46,3.58-4.37,4.18-4.82-2.13-8.72-4-9.13-4-9.13l-27.8,5.42-23.9-.68L66.92,139s.64.09,1.79.21l2.19,25.28S72.65,217,83,237.74c2.08-12.5,5.79-40.36,13.89-49.19C92.12,187.32,81.84,169,80.61,160.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_728",
    "data-name": "Trazado 728",
    className: "cls-6",
    d: "M67.66,170.85l19.9-.41,19.82.41,7.41,3.17-2.75,5.6-9.66-2.44s-16.15-1-16.65-.91-20.41,1.91-20.41,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_729",
    "data-name": "Trazado 729",
    className: "cls-6",
    d: "M89.64,132.92l3.93,3.29-1.1,11.58-7.36.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_730",
    "data-name": "Trazado 730",
    className: "cls-8",
    d: "M90.87,134.22l-1.23,13.57,10-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_731",
    "data-name": "Trazado 731",
    className: "cls-6",
    d: "M220.53,112.47a126.67,126.67,0,0,1,11,55.74,220.66,220.66,0,0,1-7.84,52.21l-3.19,3-7.7-8.09-16.37,4.9-6.82,16.41-5.88-2.45-6.37-6.86-3.12-2.21H163.91L159,241.5h-3.74l-4.86-6.38-3.91-24,38.72-42.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_732",
    "data-name": "Trazado 732",
    className: "cls-3",
    d: "M125.19,244.11s-15.69-33.74-3.93-54.82,34.52-28.44,37.12-28.32,5.74-47.92,0-64.09c10.19,5.64,6.51,3.67,6.51,3.67s22.7-9.8,28-9.55a123.26,123.26,0,0,0,7-13.24l5.84,5.85,5.93,15s19.77,27,18.59,59.81a297.32,297.32,0,0,1-7.77,63.1c-.53,2.34-5.07-1.37-5.07-1.37l-4.63-4.87-16.37,4.91-6.81,16.42-7.48-3.79-7.9-7.73H163.91L159,241.49l-5.88-1.72-6.62-14.1-11.53-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_733",
    "data-name": "Trazado 733",
    className: "cls-6",
    d: "M36.58,159.64l-10.17-15-5.07-10.82-4.41-5-9,1.14s-5.23,5.85-5.56,6.69,0,15.71,0,15.71l9.48,14.54,14.71,10.86,17.16,4.17,4.73-10.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_734",
    "data-name": "Trazado 734",
    className: "cls-3",
    d: "M2.87,148.6s1-22.83,11.77-6.51S38,173.36,58.2,174.83s48.53-2.87,52.24,2.85c-.66,5.29-1.93,6.46-1.93,6.46s-15.68-8.49-53.67-2.28C29.1,184.63,1.4,162.33,2.87,148.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_735",
    "data-name": "Trazado 735",
    className: "cls-6",
    d: "M73.79,57.51s46.09-25.34,62.1-21.09c9.31,6.69,17.48,24.19,8.66,32.85-5.07,7.35-18,14.21-20.76,16.18C120,89.53,93.9,109.3,93.9,109.3S66.76,101,66.11,100.15,62.19,74,62.19,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_736",
    "data-name": "Trazado 736",
    className: "cls-7",
    d: "M116.41,77.76c16.24-11.77,8.12-32.1-2.77-31.17C95.28,52.51,70.9,62.22,70.9,62.22V98.6l-2.34,27.62,15.15,2.92a228.52,228.52,0,0,0,34.81-9c-4.47-16.49-2.58-29.47,7.16-36a36.06,36.06,0,0,0,11-6.37C136.63,77.73,121.55,78.54,116.41,77.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1112",
    "data-name": "Grupo 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1111",
    "data-name": "Grupo 1111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1110",
    "data-name": "Grupo 1110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1081",
    "data-name": "Grupo 1081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_737",
    "data-name": "Trazado 737",
    className: "cls-5",
    d: "M125,245.58a4.49,4.49,0,0,1-3.22-1.35c-2.86-2.91-17-19.23-15.31-54.14,0-16.29,19.23-37.19,45.2-41.37,1.27-5.72,5.66-28.81-1.38-47.42l-.06-.18-1.47-5.34a2.76,2.76,0,0,1,1.92-3.39,3.1,3.1,0,0,1,.68-.1,19.66,19.66,0,0,1,14.31,5.9c5.76-3.11,20.38-9.31,27.65-9.73a121.62,121.62,0,0,0,3.68-12,3.25,3.25,0,0,1,3.95-2.37,3.21,3.21,0,0,1,1.51.85c3,3,6.23,9.72,9.49,19.56.47.69,1,1.44,1.57,2.26,7.3,10.31,22.48,31.76,19.07,86.36a204.73,204.73,0,0,1-8.08,40,3.69,3.69,0,0,1-6.1,1.39,86.24,86.24,0,0,1-5.78-6.61c-3.18.84-11.23,2.93-15.69,3.7a129,129,0,0,1-4.32,14.11,4.67,4.67,0,0,1-3,2.87,4.61,4.61,0,0,1-4.07-.63,40.92,40.92,0,0,1-10.72-11.49c-7.74.14-31.57-.7-39.81-1.59-.79,6.52-3.11,14.56-6.47,18.95a4.5,4.5,0,0,1-3.29,1.75ZM154.18,99.92c8.46,22.55,1.46,50,1.16,51.17a2.07,2.07,0,0,1-1.73,1.54c-24.23,3.29-43,22.89-43,37.56-1.68,34,12.5,49.48,14.13,51.14a.39.39,0,0,0,.27.11.3.3,0,0,0,.23-.13c3.11-4.06,5.41-12.81,5.84-18.92a2.07,2.07,0,0,1,2.21-1.93,1.87,1.87,0,0,1,.57.12c2.83.67,34,2.08,42,1.72a2.05,2.05,0,0,1,1.87,1,37.33,37.33,0,0,0,10.21,11.28.47.47,0,0,0,.43.07.55.55,0,0,0,.36-.35,123.17,123.17,0,0,0,4.49-15,2.06,2.06,0,0,1,1.78-1.61c4.39-.53,17.76-4.13,17.9-4.17a2.07,2.07,0,0,1,2.19.74s2.91,3.8,5.75,6.75a208,208,0,0,0,7.62-38.22c3.31-53-11.3-73.69-18.32-83.61-.67-.95-1.28-1.81-1.8-2.59a1.78,1.78,0,0,1-.24-.5c-3.27-9.93-5.86-14.67-7.5-16.92a122.14,122.14,0,0,1-3.9,12.12,2.09,2.09,0,0,1-2.15,1.32c-5.22-.52-23,6.67-28.18,10a2.09,2.09,0,0,1-2.74-.44,15.2,15.2,0,0,0-10.34-5.63ZM133.86,220.58l.1,0-.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1082",
    "data-name": "Grupo 1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_738",
    "data-name": "Trazado 738",
    className: "cls-5",
    d: "M194.88,169.6a61.55,61.55,0,0,1-19.94-3.44,78,78,0,0,1-25.7-14.88,3.5,3.5,0,0,1,4.77-5.12h0a72.18,72.18,0,0,0,23.42,13.46c18.21,6.18,35.25,2.93,50.65-9.63a3.5,3.5,0,1,1,4.54,5.32l-.11.1C219.37,166.12,206.3,169.6,194.88,169.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1085",
    "data-name": "Grupo 1085"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_61",
    "data-name": "Elipse 61",
    className: "cls-6",
    cx: 198.03,
    cy: 176.98,
    r: 7.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1084",
    "data-name": "Grupo 1084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1083",
    "data-name": "Grupo 1083"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_62",
    "data-name": "Elipse 62",
    className: "cls-8",
    cx: 203.73,
    cy: 178.18,
    r: 7.58
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1086",
    "data-name": "Grupo 1086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_739",
    "data-name": "Trazado 739",
    className: "cls-5",
    d: "M157.16,244.12a3.34,3.34,0,0,1-1.63-.43c-6.65-3.75-10.65-17.94-11.08-19.55a2.08,2.08,0,1,1,4-1.08c1,3.7,4.38,13.49,8.46,16.58A42.1,42.1,0,0,0,162,224a2.08,2.08,0,0,1,4.13.52c-.73,5.87-3.18,14-6.43,18.31A3.24,3.24,0,0,1,157.16,244.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1087",
    "data-name": "Grupo 1087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_740",
    "data-name": "Trazado 740",
    className: "cls-5",
    d: "M108.36,186.57A2,2,0,0,1,107,186c-3.54-3.29-8.28-5.8-30.53-3.13-20.33,2.43-47.2.89-61.63-10.74-9.93-8-16.74-25.13-14.29-36a11.58,11.58,0,0,1,8.69-9.39c9.52-2.25,11.67,2.24,14.65,8.47A62.31,62.31,0,0,0,36.68,154c15.42,15.57,30.5,15,48,14.29,1.92-.08,3.85-.16,5.8-.21,20-.57,24.88,3.76,25.38,4.25a2.08,2.08,0,0,1-2.89,3c-.2-.16-4.77-3.57-22.37-3.09l-5.75.2c-17.68.7-34.38,1.36-51.08-15.52A65.66,65.66,0,0,1,20.1,137.06c-3-6.23-3.69-7.7-10-6.22a7.45,7.45,0,0,0-5.59,6.26c-2.11,9.33,4.13,24.78,12.85,31.8,13.43,10.82,39.92,12.07,58.52,9.85,21.83-2.62,28.74-.54,33.86,4.21a2.08,2.08,0,0,1-1.42,3.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1088",
    "data-name": "Grupo 1088"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_64",
    "data-name": "Elipse 64",
    className: "cls-5",
    cx: 179.78,
    cy: 117.72,
    r: 2.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1089",
    "data-name": "Grupo 1089"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_65",
    "data-name": "Elipse 65",
    className: "cls-5",
    cx: 205.78,
    cy: 110.64,
    r: 2.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1090",
    "data-name": "Grupo 1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_741",
    "data-name": "Trazado 741",
    className: "cls-5",
    d: "M186.74,135a7.23,7.23,0,0,1-6.51-4,1.47,1.47,0,0,1,2.66-1.25h0A4.38,4.38,0,0,0,186,132c2,.3,5.61-.57,11.33-6.54a1.46,1.46,0,0,1,1.9-.2c2.36,1.65,7.6,3.12,9.73,1.7.89-.59,1.13-1.82.73-3.67a1.47,1.47,0,0,1,2.87-.63c.86,3.92-.59,5.84-2,6.75-3.32,2.22-8.92.57-12-1.08C194.19,132.73,190.2,135,186.74,135Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1091",
    "data-name": "Grupo 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_742",
    "data-name": "Trazado 742",
    className: "cls-5",
    d: "M216.34,118.73a1.47,1.47,0,0,1-.59-2.82c.46-.19,11.26-5,18.86-5.54a1.47,1.47,0,1,1,.22,2.93c-7.09.53-17.77,5.25-17.88,5.3A1.59,1.59,0,0,1,216.34,118.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1092",
    "data-name": "Grupo 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_743",
    "data-name": "Trazado 743",
    className: "cls-5",
    d: "M218.93,126.54a1.47,1.47,0,0,1-.22-2.93c.49-.07,12.16-1.84,19.65-.38a1.47,1.47,0,0,1-.56,2.89h0c-7-1.36-18.53.39-18.65.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1093",
    "data-name": "Grupo 1093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_744",
    "data-name": "Trazado 744",
    className: "cls-5",
    d: "M197.48,124.6s-11.57-4-1.41-6.49C200.73,117.62,205.44,118.1,197.48,124.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1094",
    "data-name": "Grupo 1094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_745",
    "data-name": "Trazado 745",
    className: "cls-5",
    d: "M149.41,129.42a1.47,1.47,0,0,1-1.47-1.47,1.48,1.48,0,0,1,1-1.39c7.8-2.67,22.65-1.23,23.27-1.18a1.47,1.47,0,0,1-.28,2.93c-.15,0-14.84-1.44-22,1A1.62,1.62,0,0,1,149.41,129.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1095",
    "data-name": "Grupo 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_746",
    "data-name": "Trazado 746",
    className: "cls-5",
    d: "M151,142.51a1.47,1.47,0,0,1-.78-2.72c7-4.35,21.8-6.26,22.42-6.34a1.47,1.47,0,0,1,.37,2.91c-.14,0-14.78,1.92-21.24,5.93A1.5,1.5,0,0,1,151,142.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1096",
    "data-name": "Grupo 1096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_747",
    "data-name": "Trazado 747",
    className: "cls-5",
    d: "M126.87,130.69a2.06,2.06,0,0,1-1.69-.88c-5-7-11.67-15.65-11.41-24.74l0-.63C114,96,114.27,87.28,124,82.67c8.69-4.1,15.07-7.47,18-13.45a2.08,2.08,0,0,1,3.85,1.56,1.33,1.33,0,0,1-.11.24c-3.47,7.2-10.75,11.09-19.92,15.41-7.45,3.52-7.63,10-7.85,18.13l0,.63c-.21,7.38,5.43,14.34,9.93,21.18a142,142,0,0,1,28.26-.84,2.09,2.09,0,0,1,1.83,2.31,2.07,2.07,0,0,1-2.19,1.83,139.34,139.34,0,0,0-28.58,1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1097",
    "data-name": "Grupo 1097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_748",
    "data-name": "Trazado 748",
    className: "cls-5",
    d: "M142.27,71.77a19.23,19.23,0,0,1-9-2.91,2.08,2.08,0,0,1,2.21-3.52c1.53,1,6.42,3.32,8.83,1.76,1.77-1.15,2.34-4.7,1.6-10-1.26-9.13-8-17.44-8.07-17.52a2.08,2.08,0,0,1,3.21-2.64c.31.37,7.55,9.28,9,19.59,1,7.3-.12,11.9-3.47,14.06A7.73,7.73,0,0,1,142.27,71.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1098",
    "data-name": "Grupo 1098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_749",
    "data-name": "Trazado 749",
    className: "cls-5",
    d: "M117.87,80.74A36.16,36.16,0,0,1,104.73,78a2.08,2.08,0,0,1,1.66-3.81c.17.07,12.86,5.46,20.46-.22,5.24-3.94,7.1-12.36,5.5-25.05a2.08,2.08,0,0,1,4.13-.52c1.8,14.29-.61,24-7.15,28.91A18.76,18.76,0,0,1,117.87,80.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1099",
    "data-name": "Grupo 1099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_750",
    "data-name": "Trazado 750",
    className: "cls-5",
    d: "M134.34,47.87a13.06,13.06,0,0,1-5.83.3,16.2,16.2,0,0,1-6.28-1.94,5.76,5.76,0,0,1-3.2-3.54,4.64,4.64,0,0,1-.07-4c1.83-2.66,5.55-4.11,8.52-5a25.71,25.71,0,0,1,7.44-1.13,6.35,6.35,0,0,1,3.93,1.16,6,6,0,0,1,1.92,5,17.5,17.5,0,0,1-3,7.12,5.06,5.06,0,0,1-4.34,2.23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1100",
    "data-name": "Grupo 1100"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_66",
    "data-name": "Elipse 66",
    className: "cls-5",
    cx: 93.9,
    cy: 59.3,
    r: 2.94
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1101",
    "data-name": "Grupo 1101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_751",
    "data-name": "Trazado 751",
    className: "cls-5",
    d: "M83.7,50.39S83.88,5,105.56.78s29.76,9.92,27.38,12-29.58,16.35-39,34A28.61,28.61,0,0,1,83.7,50.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1102",
    "data-name": "Grupo 1102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_752",
    "data-name": "Trazado 752",
    className: "cls-5",
    d: "M77.15,56.05a2.08,2.08,0,0,1-.82-4c1.61-.68,39.43-16.81,52.38-19.15a2.08,2.08,0,0,1,.74,4.09C117,39.26,78.35,55.72,78,55.88A2,2,0,0,1,77.15,56.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1103",
    "data-name": "Grupo 1103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_753",
    "data-name": "Trazado 753",
    className: "cls-5",
    d: "M79.49,53s-5.8,12.92-3.93,55.07a6.36,6.36,0,0,1-4.88,6.49,57.89,57.89,0,0,1-24.34,0,6.35,6.35,0,0,1-5-6.88C43.14,90.38,48.86,41.94,79.49,53Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1104",
    "data-name": "Grupo 1104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_754",
    "data-name": "Trazado 754",
    className: "cls-5",
    d: "M80.45,246.68a4,4,0,0,1-3-1.31c-9.33-10.07-14.09-30.89-14.56-63.65a2.07,2.07,0,0,1,2-2.1h0a2.08,2.08,0,0,1,2.08,2c.44,30.66,4.81,51,13,60.36,1-6.71,6.93-46.82,14.66-54.82a2.08,2.08,0,0,1,3,2.89c-5.44,5.63-11.14,35-13.66,53.38a3.62,3.62,0,0,1-2.51,3A3.86,3.86,0,0,1,80.45,246.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1105",
    "data-name": "Grupo 1105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_755",
    "data-name": "Trazado 755",
    className: "cls-5",
    d: "M65,171.71h0a2.08,2.08,0,0,1-2-2.11h0a547.14,547.14,0,0,1,3.82-55.32,2.08,2.08,0,1,1,4.13.53,541,541,0,0,0-3.78,54.85A2.09,2.09,0,0,1,65,171.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1106",
    "data-name": "Grupo 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_756",
    "data-name": "Trazado 756",
    className: "cls-5",
    d: "M108.36,196.87a2.17,2.17,0,0,1-.62-.1,40.7,40.7,0,0,1-21-15.79,2.08,2.08,0,0,1,3.38-2.42A36.62,36.62,0,0,0,109,192.8a2.08,2.08,0,0,1-.62,4.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1107",
    "data-name": "Grupo 1107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_757",
    "data-name": "Trazado 757",
    className: "cls-5",
    d: "M83,172.52a2.05,2.05,0,0,1-1.88-1.21,65.53,65.53,0,0,1-5-15.51,2.08,2.08,0,0,1,4.1-.66,62.59,62.59,0,0,0,4.68,14.43,2.07,2.07,0,0,1-1,2.76,2,2,0,0,1-.87.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1108",
    "data-name": "Grupo 1108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_758",
    "data-name": "Trazado 758",
    className: "cls-5",
    d: "M85.67,133.79c-14.37,0-22.09-5.22-22.62-5.58a5.15,5.15,0,0,1,5.86-8.46c.78.52,17.7,11.23,50.84-5.73a5.15,5.15,0,0,1,4.69,9.16h0C108.5,131.34,95.52,133.79,85.67,133.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1109",
    "data-name": "Grupo 1109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_759",
    "data-name": "Trazado 759",
    className: "cls-5",
    d: "M85.23,149.71a1.47,1.47,0,0,1-1.47-1.47,1.27,1.27,0,0,1,.06-.39l4.52-16.17a1.47,1.47,0,0,1,1.81-1,1.51,1.51,0,0,1,.79.54l9.94,13.39a1.46,1.46,0,0,1-.9,2.32l-14.47,2.78Zm5.14-14.36-3.08,11,9.83-1.89Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1121",
    "data-name": "Grupo 1121"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_67",
    "data-name": "Elipse 67",
    className: "cls-6",
    cx: 198.03,
    cy: 176.98,
    r: 7.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1120",
    "data-name": "Grupo 1120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1119",
    "data-name": "Grupo 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1118",
    "data-name": "Grupo 1118"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_68",
    "data-name": "Elipse 68",
    className: "cls-8",
    cx: 203.73,
    cy: 178.18,
    r: 7.58
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_783",
    "data-name": "Trazado 783",
    className: "cls-5",
    d: "M198,186.72a9.75,9.75,0,1,1,9.75-9.75A9.73,9.73,0,0,1,198,186.72Zm0-15.5a5.75,5.75,0,1,0,5.75,5.75,5.75,5.75,0,0,0-5.75-5.75Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCatDog);
export default __webpack_public_path__ + "static/media/logo-cat-dog.77b59898e6810d5ea12850464c273227.svg";
export { ForwardRef as ReactComponent };